import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const gendaiTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#b7393b',
    },
    secondary: {
      main: '#05c3de',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#b7393b',
    },
  },
};
